var _effectorFileName = "/builds/gmini/front-ui-kit/src/TextField/TextField.tsx";
import React from 'react';
import { Input, InputWrapper, ResetButton } from './TextField.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TextField = ({
  onChange,
  onFocus,
  onBlur,
  value,
  placeholder,
  autofocus,
  background,
  disabled,
  error,
  inputRef,
  clearable,
  inputStyles,
  onKeyDown,
  ...other
}) => /*#__PURE__*/_jsxs(InputWrapper, {
  children: [/*#__PURE__*/_jsx(Input, {
    onChange: event => onChange(event.target.value),
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    placeholder: placeholder,
    autoFocus: autofocus,
    background: background,
    disabled: disabled,
    error: error,
    ref: inputRef,
    clearable: clearable,
    style: inputStyles,
    onKeyDown: onKeyDown,
    ...other
  }), value && clearable && /*#__PURE__*/_jsx(ResetButton, {
    onClick: () => onChange('')
  })]
});